import { Breadcrumbs, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import style from '../../sections/@dashboard/projectSettings/ProjectSetting.module.css';

function BreadCrumb({ breadcrumbs }) {
  return (
    <Breadcrumbs className={style.navigationLink} separator={<ArrowForwardIosIcon fontSize="small" />}>
      {breadcrumbs.map((breadcrumb, index) => {
        const isLast = index === breadcrumbs.length - 1;
        return (
          <Link
            key={breadcrumb.path}
            component={isLast ? 'span' : Link} // Use 'span' to disable the last link
            to={isLast ? null : breadcrumb.path}
            className={isLast ? style.disabledLink : style.navigationLink}
            onClick={(e) => isLast && e.preventDefault()} // Prevent default for the last link
          >
            <Typography variant="h6">{breadcrumb.label}</Typography>
          </Link>
        );
      })}
    </Breadcrumbs>
  );
}

export default BreadCrumb;
